module.exports = __webpack_public_path__ + "img/aktuelles_adventsfenster.72276c55.png";